var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("北京艾西智酷科技有限公司 | Copyright ©2021 minisek.com | 京ICP备19032638号-4")]),_vm._v(" "),_c('p',[_vm._v("地址 : 北京市海淀区丰豪东路9号 | 联系邮箱：fengguoqiang@iczhiku.com | 电话：18610269133（工作日9:00-18:00）")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c53250f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/footer.vue
// module id = null
// module chunks = 